export default "__VITE_ASSET__CvUrida2__"